import CreatorPaymentMethodPage from "./CreatorPaymentMethodPage";

export default CreatorPaymentMethodPage;
